import { createI18n } from 'vue-i18n'
import {
  registerMessageCompiler,
  compile,
  registerMessageResolver,
  resolveValue,
  registerLocaleFallbacker,
  fallbackWithLocaleChain,
} from '@intlify/core-base'
import fr from './locales/fr'
import nl from './locales/nl'
import en from './locales/en'
import de from './locales/de'

export const LOCALES = ['fr', 'nl', 'en', 'de'] as const
export const DEFAULT_LOCALE = 'fr'

export const LOCALE_INFO = [
  { code: 'fr', name: 'Français', iso: 'fr-FR' },
  { code: 'nl', name: 'Nederlands', iso: 'nl-BE' },
  { code: 'en', name: 'English', iso: 'en-US' },
  { code: 'de', name: 'Deutsch', iso: 'de-DE' },
] as const

// Register message compiler for production builds (vue-i18n v12 alpha)
registerMessageCompiler(compile)
registerMessageResolver(resolveValue)
registerLocaleFallbacker(fallbackWithLocaleChain)

const i18n = createI18n({
  legacy: false,
  locale: DEFAULT_LOCALE,
  fallbackLocale: DEFAULT_LOCALE,
  messages: { fr, nl, en, de },
})

export default i18n
